import { useState, useContext } from "react";
import { mensajeSimple, modalCargando, modalEjecutar } from "../../components/ui/sweetAlerts";
import { obtenerPosicionesLaboralesApi } from "../../api/contratacion/datosLaboralesApi";
import { DataContextContractual, DataContext } from "../../contextData/contextData";
import { validarRespPeticion } from "../../forms/contratacion/validation";
import { formatFecha, tokenExpirado } from "../../utils/funciones";
import { TIPO_SOLICITUD } from "../../utils/Constants";
import { useLocation } from "react-router-dom";
import { post, postWithResponse } from "../../api/apis";
import { useFormik } from "formik";
import moment from "moment";

const mensajeGuardar = "¿Está seguro(a) de aprobar la solicitud?";

const nombreInstalacion = id => document.querySelector(`div#${id} div.limpiarSelect__single-value`).textContent;

const mensajeCambio = (props, values) => {
  const { colab, instalacion, fecha, tipo } = props;

  return ({
    1: `Se procedera a solicitar un cambio de cargo para el cobaborador(a): <b>${colab}</b>, desea continuar?`,
    2: `Se procedera a solicitar un cambio de unidad(Temporis) para el cobaborador(a): <b>${colab}</b>, desea continuar?`,
    3: `Para el cobaborador(a): <b>${colab}</b> está solicitando un cambio de instalación a: <b>${instalacion}</b> con fecha efectiva <b>${fecha}</b>`,
    4: `Se solicitará un cambio de estatus de contrato para el colaborador(a): <b>${colab}</b>, desea continuar?`,
    5: `Para el cobaborador(a): <b>${colab}</b> está solicitando una desvinculación, desea continuar?`
  }[tipo] || mensajeGuardar)
}

const returnIdPersona = (respObj) => {
  let obj = {};
  if ([201].includes(respObj.status)) {
    obj = respObj.data.data.id_persona;
  }
  if ([200].includes(respObj.status)) {
    obj = respObj.data.id_persona;
  }
  return obj;
}

export const useCambioCargo = (tipoProp) => {
  const [posicionesLaborales, setPosicionesLaborales] = useState([]);
  const { uno, dataObj } = useContext(DataContext);
  const { diasAnticipo, tipoSolicitud: tipoContext } = useContext(DataContextContractual);
  const tipoSolicitud = tipoProp || tipoContext;
  const [documentos, setDocumentos] = useState([]);
  const location = useLocation();

  const getDatos = async () => {
    const posiciones = await obtenerPosicionesLaboralesApi();

    console.log(posiciones.data);

    if (posiciones.status === "success") {
      setPosicionesLaborales(posiciones.data);
    }
  }

  const setDato = (llave, valor) => {
    formik.setValues({ ...formik.values, [llave]: valor });
  }

  const validate = (obj) => {
    let errObj = {};
    if (![5].includes(tipoSolicitud)) {
      if (!["01"].includes(obj.fecha_inicio_cambio.split("-")[2])) errObj.fecha_inicio_cambio = 'Solo primer día (01) de cada mes';
      if (moment(formik.values.fecha_inicio_cambio).diff(moment(new Date()), "days") < diasAnticipo) {
        errObj.fecha_inicio_cambio = 'Fecha fuera de rango. Validar con Remuneraciones.';
      }
    }
    if (!obj.fecha_inicio_cambio) errObj.fecha_inicio_cambio = 'Requerido';

    if ([1].includes(tipoSolicitud)) { // 1 = CAMBIO CARGO
      if (!obj.cod_sap_nuevo_cargo) errObj.cod_sap_nuevo_cargo = 'Requerido';
    }
    if ([1, 2].includes(tipoSolicitud)) { // 1 = CAMBIO CARGO, 2 = CAMBIO DE UNIDAD
      if (!obj.nueva_unidad_organizativa) errObj.nueva_unidad_organizativa = 'Requerido';
      if (!obj.nuevo_plan_horario) errObj.nuevo_plan_horario = 'Requerido';
    }

    if ([3].includes(tipoSolicitud)) { // 3 = CAMBIO DE INSTALACION
      if (!obj.unidad_destino) errObj.unidad_destino = 'Requerido';
      if (!obj.instalacion_administrador) errObj.instalacion_administrador = 'Requerido';
    }

    if ([4].includes(tipoSolicitud)) {
      if (!obj.tipo_cambio_contrato) errObj.tipo_cambio_contrato = 'Requerido';
      if (["02"].includes(obj.tipo_cambio_contrato) && !obj.fecha_renovacion_contrato) {
        errObj.fecha_renovacion_contrato = "Requerido";
      }
    }

    if ([5].includes(tipoSolicitud)) { // 5 = DESVINCULACION COLABORADOR
      if (!obj.id_clausula_despido) errObj.id_clausula_despido = 'Requerido';
      if (!obj.motivo_desvinculacion) errObj.motivo_desvinculacion = 'Requerido';
    }

    if (![1].includes(tipoSolicitud)) { return errObj; } //solo cambio de cargo son documentos oblicatorios

    if (obj.documentosAdicionales.length === 0) errObj.documentosAdicionales = 'Requerido (mínimo un documento)';

    return errObj;
  }

  const modalExitoCerrar = () => {
    mensajeSimple("success", "Guardado con éxito", 2000);
    document.querySelector('.btn-close').click();
  }

  const submitDocumentos = async (obj, idSolicitud) => {
    let arreglo = [];

    for (const elm of obj.documentosAdicionales) {
      const formData = new FormData();
      formData.append("documento", elm, elm.name);
      formData.append("id_solicitud_cc", idSolicitud);

      const resp = await post('documentoscambiocc', {}, formData);
      arreglo.push(resp.status);
    }

    setTimeout(() => {
      document.querySelector('.btn-close').click();

      arreglo.some(el => el !== 200)
        ? mensajeSimple("error", "Ocurrio un problema con el guardado de documentos", 2000)
        : mensajeSimple("success", "Guardado con éxito", 2000);

      if (["/solicitudes-traspaso"].includes(location.pathname)) {
        setTimeout(() => { window.location.reload() }, 2000);
      }
    }, 3000);
  }

  const submitForm = async (obj) => {
    modalCargando("Validando datos...");
    const data = JSON.parse(JSON.stringify(obj));

    //veo en tal caso que no exista...
    if (!uno["estructura"]) {
      uno["estructura"] = JSON.parse(data.cod_sap_nuevo_cargo);
    }

    data.nombre_cargo_actual = `${uno["REEO_PLAN_HORARIO"]}|${uno["estructura"]["MOES_DESCRIPCION_POSICION"]}`;
    data.instalacion_actual = uno["estructura"]["MOES_NOMBRE_UNIDAD_ORGANIZATIV"];

    if ([1].includes(tipoSolicitud) && obj.cod_sap_nuevo_cargo) {
      const objetoCargo = JSON.parse(obj.cod_sap_nuevo_cargo);
      data.nombre_nuevo_cargo = objetoCargo["MOES_DESCRIPCION_POSICION"];
    }

    if ([2].includes(tipoSolicitud)) {
      data.cod_sap_nuevo_cargo = uno["estructura"]["MOES_COD_POSICION"];
      data.moes_cod_division = uno["estructura"]["MOES_COD_DIVISION"];
      data.moes_cod_sub_division = uno["estructura"]["MOES_COD_SUB_DIVISION"];
      data.moes_id_grupo_de_personal = uno["estructura"]["MOES_ID_GRUPO_DE_PERSONAL"];
      data.moes_id_area_de_personal = uno["estructura"]["MOES_ID_AREA_DE_PERSONAL"];
      data.moes_cod_funcion = uno["estructura"]["MOES_COD_FUNCION"];
      data.moes_cod_unidad_organizativa = uno["estructura"]["MOES_COD_UNIDAD_ORGANIZATIVA"];
      data.moes_id_area_de_nomina = uno["estructura"]["MOES_ID_AREA_DE_NOMINA"];
      data.cod_sap_jefe_unidad_destino = uno["estructura"]["MOES_JEFE_UNIDAD_COD_SAP"];
    }

    if ([1, 2, 3].includes(tipoSolicitud)) {
      data.moes_id_grupo_de_personal = uno["estructura"]["MOES_ID_GRUPO_DE_PERSONAL"];
      data.moes_id_area_de_personal = uno["estructura"]["MOES_ID_AREA_DE_PERSONAL"];
      data.moes_cod_funcion = uno["estructura"]["MOES_COD_FUNCION"];
      data.moes_cod_unidad_organizativa = uno["estructura"]["MOES_COD_UNIDAD_ORGANIZATIVA"];
      data.moes_id_area_de_nomina = uno["estructura"]["MOES_ID_AREA_DE_NOMINA"];
    }

    if ([1, 3].includes(tipoSolicitud) && obj.cod_sap_nuevo_cargo) {
      const objetoCargo = JSON.parse(obj.cod_sap_nuevo_cargo);
      data.cod_sap_nuevo_cargo = JSON.parse(obj.cod_sap_nuevo_cargo)["MOES_COD_POSICION"];
      data.moes_cod_division = objetoCargo["MOES_COD_DIVISION"];
      data.moes_cod_sub_division = objetoCargo["MOES_COD_SUB_DIVISION"];
      data.cod_sap_jefe_unidad_destino = objetoCargo["MOES_JEFE_UNIDAD_COD_SAP"];
    }

    if ([1, 2].includes(tipoSolicitud)) {
      data.descripcion_unidad_temporis = document.querySelector("#nueva_unidad_organizativa .limpiarSelect__single-value").innerText;
      data.tipo_contrato = uno["REEO_TIPO_CONTRATO"];
    }

    if ([3].includes(tipoSolicitud)) {
      const { JEFE, ADMIN } = formik.values.instalacion_administrador;
      data.cod_sap_jefe_unidad_destino = JEFE["REEO_CODIGO_SAP"];
      data.cod_sap_administrador_destino = ADMIN["REEO_CODIGO_SAP"];

      data.cod_sap_cargo_actual = uno["estructura"]["MOES_COD_POSICION"];
      data.tipo_contrato = uno["REEO_TIPO_CONTRATO"];
      data.nombre_instalacion_destino = nombreInstalacion("instalacion_administrador"); //test
    }

    if ([1, 2, 3, 4].includes(tipoSolicitud) && obj.nueva_unidad_organizativa) {
      data.nueva_unidad_organizativa = obj.nueva_unidad_organizativa.IdUnidadorganizativa;
      data.localcodigoerp = obj.nueva_unidad_organizativa.Localcodigoerp;
      data.idunidadorganizativa = obj.nueva_unidad_organizativa.IdUnidadorganizativa;
      data.idcargogenerico = obj.nueva_unidad_organizativa.IdCargogenerico;
      data.idplanhorario = obj.nueva_unidad_organizativa.IdPlanhorario;
    }

    if (![4].includes(tipoSolicitud)) delete data.tipo_cambio_contrato;

    if ([4].includes(tipoSolicitud) && !["02"].includes(data.tipo_cambio_contrato)) {
      delete data.fecha_renovacion_contrato
    }

    if (![3].includes(tipoSolicitud)) {
      data.cod_sap_jefe = dataObj.jefe_directo["REEO_CODIGO_SAP"];
    }
    data.correo_sap_jefe = dataObj.jefe_directo["REEO_CORREO_EMPRESA"];
    data.cod_sap_rrhh_responsable = dataObj.ejecutivo_rrhh["REEO_CODIGO_SAP"];
    data.cod_sap_administrador = localStorage.getItem("id_usuario_sap");


    if ([1].includes(tipoSolicitud)) {
      const cod_posicion = JSON.parse(obj.cod_sap_nuevo_cargo).MOES_COD_POSICION;

      modalCargando(`Bloqueando posición ${cod_posicion}`);
      const resp = await post('bloqueoposicion', { codPosicion: cod_posicion, fechaInicio: obj.fecha_inicio_cambio });

      if (resp.data.status === 'info') {
        mensajeSimple('info', resp.data.message, 4500); 
        return;
      }
    }


    const resp_persona = await post('persona', {}, {
      nombre: uno["REEO_NOMBRES"],
      apellido_pat: uno["REEO_APELLIDO_PATERNO"],
      identificacion: uno["REEO_RUT"],
      tipo_contrato: uno["REEO_TIPO_CONTRATO"],
    });


    data.cod_sap_cargo_actual = uno["REEO_CODIGO_POSICION"];
    const idPersona = returnIdPersona(resp_persona);

    data.id_tipo_solicitud = (location.pathname === "/solicitudes-traspaso") ? 3 : tipoSolicitud;
    if (location.pathname === "/solicitudes-traspaso") { data.id = uno["ID"]; }

    if (["number"].includes(typeof idPersona)) {
      data.id_persona = idPersona;
      modalCargando(`${tipoSolicitud === 5 ? 'Enviando' : 'Guardando'} ${TIPO_SOLICITUD[tipoSolicitud]}...`);
      const resp = await postWithResponse('getlistado', {}, data);

      if ([3].includes(tipoSolicitud)) {
        if (validarRespPeticion(resp)) {
          modalExitoCerrar();
        }
        return;
      }

      if (validarRespPeticion(resp)) {
        if (obj.documentosAdicionales.length > 0) {
          submitDocumentos(obj, resp.data.id);
        }
        else {
          modalExitoCerrar();
        }
      }
    }
  }

  const formik = useFormik({
    initialValues: {
      id_persona: '',
      id_tipo_solicitud: '',
      aprueba: true,
      cod_sap_jefe: '',
      cod_sap_nuevo_cargo: '',
      cod_sap_rrhh_responsable: '',
      fecha_inicio_cambio: '',
      nueva_unidad_organizativa: '',
      nuevo_plan_horario: '',
      unidad_destino: '',
      cod_sap_jefe_unidad_destino: '',
      instalacion_administrador: '',
      motivo_desvinculacion: '',
      id_clausula_despido: '',
      tipo_cambio_contrato: '',
      documentosAdicionales: [],
    },
    validate,
    onSubmit: (values) => {
      modalEjecutar(() => {
        submitForm(values)
      },
        mensajeCambio({
          tipo: tipoSolicitud,
          fecha: formatFecha(values.fecha_inicio_cambio),
          colab: uno["REEO_NOMBRES"],
          instalacion: [3].includes(tipoSolicitud) ? nombreInstalacion("instalacion_administrador") : '',
        }), values);
    },
    validateOnChange: true,
  });

  const submitCambioCargo = async (obj) => {
    if (obj?.preventDefault) {
      obj.preventDefault();
    }

    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.submitForm();
      return;
    }

    // if ([1].includes(tipoSolicitud)) {
    //   const cod_posicion = JSON.parse(obj.cod_sap_nuevo_cargo).MOES_COD_POSICION;

    //   modalCargando(`Bloqueando posición ${cod_posicion}`);
    //   const resp = await post('bloqueoposicion', { codPosicion: cod_posicion, fechaInicio: obj.fecha_inicio_cambio });

    //   if (resp.data.status === 'info') { mensajeSimple('info', resp.data.message, 4500); }
    //   else if (resp.data.status === 'success') { formik.submitForm(); }
    // } else {
      formik.submitForm();
    // }
  }



  return {
    formik, setDato, posicionesLaborales, getDatos, submitCambioCargo, documentos, setDocumentos
  }
} 